// extracted by mini-css-extract-plugin
module.exports = {"cover":"MediaCoverImage_cover__RH_qy"};